import axios from "axios";
import Cookies from "js-cookie";

// config
import config from "Config";

const requestInstance = () => {
	const headers = {
		Authorization: Cookies.get("logan-auth-token"),
	};

	return axios.create({
		headers,
		withCredentials: true,
	});
};

export const processConfig = {
	logging: 1,
	baseURL: config.APIHost,
};

export default requestInstance;
